module.exports = __webpack_public_path__ + "img/doc_1_preview.34e41d21.jpg";